import React, { Fragment, PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import i18n from "i18next";

import { FeedbackPopup } from "../Layout/FeedbackPopup";
import { FormDropDown, FormMultiDropdown } from "../Common";
import { checkIsInternalUser } from "../../helpers/Authorization/authorizationHelpers";
import { dateDisplayFormats } from "../../helpers/dateHelpers";
import { defaultOrderListView } from "../../helpers/selectionViewHelpers";
import { getFiltersValues, getGroupedFiltersValues } from "../Customer/Filters/FilterHelpers";
import { languageDisplayFormats } from "../../helpers/Language/languageHelpers";
import ButtonsBlock from "../Common/UnitsSelector//ButtonsBlock";

class UserPreferencesForm extends PureComponent {
  static propTypes = {
    onChangeMetadata: PropTypes.func.isRequired,
    customersSelections: PropTypes.array,
    unitOfMeasurements: PropTypes.array,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    customersSelections: [],
    unitOfMeasurements: [],
    userMetadata: {}
  };

  state = {
    saved: false
  };

  handleFieldChange = (_field, value, _oldValue, fieldName, shouldSetSessionPreferences = false) => {
    if (!this.state.saved) {
      this.setState({ saved: true });
      setTimeout(() => this.setState({ saved: false }), 1450);
    }

    this.props.onChangeMetadata(fieldName, value, shouldSetSessionPreferences);
  };

  handleUnitsChange = (unit, type) => this.handleFieldChange(null, unit, null, `unitOfMeasurements.${type}`, true);

  handleFormSubmit = e => e.preventDefault();

  render() {
    const isInternal = checkIsInternalUser();
    return (
      <form className="preferences" onSubmit={this.handleFormSubmit}>
        <div className="preferences__block">
          <Field
            component={FormDropDown}
            data={dateDisplayFormats}
            name="dateDisplayFormat"
            placeholder={i18n.t("dropdown.select")}
            label={i18n.t("userPreferences.dateDisplayFormat")}
            onChange={this.handleFieldChange}
          />
          <Field
            component={FormDropDown}
            data={languageDisplayFormats}
            name="language"
            placeholder={i18n.t("dropdown.select")}
            label={i18n.t("userPreferences.language")}
            onChange={this.handleFieldChange}
          />
        </div>

        <div className="preferences__block">
          <ButtonsBlock
            unitOfMeasurements={this.props.unitOfMeasurements}
            userUnits={this.props.userMetadata.unitOfMeasurements}
            onSelectedUnit={this.handleUnitsChange}
          />
        </div>

        <div className="preferences__block">
          {isInternal && (
            <Fragment>
              <span className="preferences__fieldset-label">{i18n.t("userPreferences.defaultCustomerSelectionView")}</span>
              <div className="preferences__customer-filters">
                <Field
                  component={FormMultiDropdown}
                  className="preferences__fieldset"
                  data={getFiltersValues(this.props.customersSelections, "assignedTo")}
                  optionGroupsValues={getGroupedFiltersValues(this.props.customersSelections, "assignedTo", "representativeTypeValue")}
                  placeholder={i18n.t("customer.assignedTo")}
                  name="customersFilters.assignedTo"
                  onChange={this.handleFieldChange}
                />
                <Field
                  component={FormMultiDropdown}
                  className="preferences__fieldset"
                  data={getFiltersValues(this.props.customersSelections, "product")}
                  optionGroupsValues={getGroupedFiltersValues(this.props.customersSelections, "product", "bookOfBusinessValue")}
                  placeholder={i18n.t("products.product")}
                  name="customersFilters.product"
                  onChange={this.handleFieldChange}
                />
                <Field
                  component={FormMultiDropdown}
                  className="preferences__fieldset"
                  data={getFiltersValues(this.props.customersSelections, "mill")}
                  placeholder={i18n.t("customer.mill")}
                  name="customersFilters.mill"
                  onChange={this.handleFieldChange}
                />
                <Field
                  component={FormMultiDropdown}
                  className="preferences__fieldset"
                  data={getFiltersValues(this.props.customersSelections, "customerType")}
                  placeholder={i18n.t("customer.customerType")}
                  name="customersFilters.customerType"
                  onChange={this.handleFieldChange}
                />
              </div>
            </Fragment>
          )}
          <Field
            component={FormDropDown}
            data={defaultOrderListView()}
            name="defaultOrderListView"
            placeholder={i18n.t("dropdown.select")}
            label={i18n.t("userPreferences.defaultOrderListView")}
            onChange={this.handleFieldChange}
          />
        </div>
        {this.state.saved && <FeedbackPopup />}
      </form>
    );
  }
}

export default reduxForm({ form: "userPreferences", enableReinitialize: true })(UserPreferencesForm);



// WEBPACK FOOTER //
// ./src/components/UserPreferences/UserPreferencesForm.js